import { Controller } from '@hotwired/stimulus';
import { intervalToDuration, formatDuration } from 'date-fns';

export class CountdownController extends Controller {
  static targets = ['timer'];
  static values = {
    completedText: {
      type: String,
      default: 'Complete',
    },
    targetDate: String,
  };

  connect() {
    this.alignInterval();
  }

  disconnect() {
    clearInterval(this.interval);

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  alignInterval() {
    const now = new Date();
    const msToNextSecond = 1000 - now.getMilliseconds();

    this.timeout = setTimeout(() => {
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }, msToNextSecond);
  }

  updateCountdown() {
    const targetDate = new Date(this.targetDateValue);
    const now = new Date();
    const timeRemaining = targetDate - now;

    if (timeRemaining <= 1000) {
      this.element.textContent = this.completedTextValue;
      clearInterval(this.interval);
      return;
    }

    this.timerTarget.textContent = formatDuration(
      intervalToDuration({ start: now, end: targetDate })
    );
  }
}
